import React from "react";
import { useTranslation } from "react-i18next";
import cln from "classnames";
import { useCartData } from "../../../providers/cartDataStore";
import { useConfig } from "../../../providers/config";
import { prettifyNumbers } from "../../../utils/prettifyNumbers";

interface TotalWeightAndPriceProps {
  isTaxiMasterTurned: boolean;
}

export const TotalWeightAndPrice = ({ isTaxiMasterTurned }: TotalWeightAndPriceProps) => {
  const config = useConfig();
  const { t } = useTranslation();
  const { getProductsTotalWeight, cartSubtotalValue } = useCartData();

  const totalWeight = getProductsTotalWeight();
  const totalWeightRounded = prettifyNumbers(totalWeight);
  const cartSubtotalValueRounded = prettifyNumbers(cartSubtotalValue);

  const isWeightExceeded = totalWeight > config.maxWeightForOrderKG!;

  return (
    <div className="flex items-center justify-between gap-2 px-2.5 py-5 border-solid border-b-1 border-gray-200">
      <span className=" text-[#292929]">{t("Total")}</span>
      <div className="flex items-center gap-2 font-bold">
        <div className={cln(isWeightExceeded && !isTaxiMasterTurned ? "text-red-400" : "text-[#292929]")}>
          {totalWeightRounded} кг
        </div>
        <span className="text-sm text-[#292929]">-</span>
        <div>{cartSubtotalValueRounded} ₽</div>
      </div>
    </div>
  );
};
